(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teck-gallery-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teck-image-compare')) {
  customElements.define('teck-image-compare', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const activeOptions = { ...options, passive: false };
      const range = this.querySelector('input');
      const stage = this.querySelector('.teck-gallery-compare__stage');
      let activePointer = null;
      const update = () => stage.style.setProperty('--compare-position', range.value + '%');
      const move = clientX => {
        const rect = stage.getBoundingClientRect();
        if (!rect.width) return;
        range.value = String(Math.round(Math.max(0, Math.min(100, (clientX - rect.left) / rect.width * 100))));
        update();
      };
      range.addEventListener('input', update, options);
      range.addEventListener('pointerdown', event => {
        if (event.button !== 0 && event.pointerType === 'mouse') return;
        event.preventDefault();
        event.stopPropagation();
        activePointer = event.pointerId;
        range.setPointerCapture(event.pointerId);
        move(event.clientX);
      }, activeOptions);
      range.addEventListener('pointermove', event => {
        if (activePointer !== event.pointerId) return;
        event.preventDefault();
        event.stopPropagation();
        move(event.clientX);
      }, activeOptions);
      const end = event => {
        if (event.pointerId !== activePointer) return;
        event.stopPropagation();
        activePointer = null;
        if (range.hasPointerCapture(event.pointerId)) range.releasePointerCapture(event.pointerId);
      };
      range.addEventListener('pointerup', end, options);
      range.addEventListener('pointercancel', end, options);
      range.addEventListener('lostpointercapture', () => { activePointer = null; }, options);
      range.addEventListener('touchstart', event => {
        event.stopPropagation();
        if (!window.PointerEvent && event.touches.length === 1) {
          event.preventDefault();
          move(event.touches[0].clientX);
        }
      }, activeOptions);
      range.addEventListener('touchmove', event => {
        event.stopPropagation();
        if (event.touches.length === 1) {
          event.preventDefault();
          if (!window.PointerEvent) move(event.touches[0].clientX);
        }
      }, activeOptions);
      range.addEventListener('click', event => event.stopPropagation(), options);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["teck-mini-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('teck-mini-reviews')){
customElements.define('teck-mini-reviews',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.track=this.querySelector('.teck-mini-reviews__track');this.cards=[...this.querySelectorAll('[data-review]')];this.dots=[...this.querySelectorAll('button')];this.n=this.cards.length;
if(this.n<2)return;
for(let copy=0;copy<2;copy++){const fragment=document.createDocumentFragment();this.cards.forEach(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');fragment.append(clone)});if(copy===0)this.track.prepend(fragment);else this.track.append(fragment)}
this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.observer=new ResizeObserver(()=>{this.width=this.track.clientWidth;this.track.scrollLeft=this.n*this.width});this.observer.observe(this.track);
this.track.addEventListener('scroll',()=>{clearTimeout(this.settle);this.settle=setTimeout(()=>{const index=Math.round(this.track.scrollLeft/this.width);this.index=((index%this.n)+this.n)%this.n;this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});if(index<this.n||index>=2*this.n)this.track.scrollLeft=(this.n+this.index)*this.width},120)},{passive:true});
this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.stop();this.go(this.n+i)}));
this.track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.stop();this.go(Math.round(this.track.scrollLeft/this.width)+(event.key==='ArrowRight'?1:-1))}});
this.addEventListener('pointerdown',()=>this.stop(),{passive:true});this.addEventListener('focusin',()=>this.stop());this.addEventListener('mouseenter',()=>this.stop());
if(this.dataset.autoplay==='true'&&!this.reduced)this.timer=setInterval(()=>{if(!document.hidden)this.go(Math.round(this.track.scrollLeft/this.width)+1)},5000);
}
go(index){this.track.scrollTo({left:index*this.width,behavior:this.reduced?'instant':'smooth'})}
stop(){clearInterval(this.timer)}
disconnectedCallback(){this.stop();clearTimeout(this.settle);this.observer?.disconnect()}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["teck-sticky-buy"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('teck-sticky-buy'))customElements.define('teck-sticky-buy',class extends HTMLElement{
connectedCallback(){
const form=document.getElementById('product-form-'+this.dataset.section);
const source=form?.querySelector('[type="submit"]');
if(!source)return;
const button=this.querySelector('button'),label=button.querySelector('span'),initial=label.textContent;
let lastY=window.scrollY,up=false,busy=false;
this.abort=new AbortController();
const sync=()=>{
const drawer=document.querySelector('cart-drawer');
this.hidden=!up||source.getBoundingClientRect().bottom>=0||drawer?.classList.contains('active')||!!document.querySelector('dialog[open],.quick-add-modal[open]');
button.disabled=busy;
};
button.addEventListener('click',async()=>{
if(button.disabled)return;
busy=true;label.textContent='Ajout en cours…';sync();
try{
const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
const data=new FormData(form);
const variantId=form.querySelector('[name="id"]')?.value||this.dataset.variant;
if(!variantId)throw new Error('Produit indisponible. Actualisez la page.');
data.set('id',variantId);
if(!data.get('quantity'))data.set('quantity','1');
if(cart){data.set('sections',cart.getSectionsToRender().map(s=>s.id).join(','));data.set('sections_url',window.location.pathname);cart.setActiveElement(button)}
const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'},body:data});
const result=await response.json();
if(!response.ok||result.status)throw new Error(result.description||'Ajout impossible. Réessayez.');
if(cart){cart.classList.remove('is-empty');cart.renderContents(result)}
else window.location.assign(window.routes?.cart_url||'/cart');
if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'teck-sticky-buy',productVariantId:data.get('id'),cartData:result});
label.textContent=initial;
}catch(error){label.textContent=error.message;setTimeout(()=>{label.textContent=initial},4000)}
finally{busy=false;sync()}
},{signal:this.abort.signal});
window.addEventListener('scroll',()=>{
const y=window.scrollY,delta=y-lastY;
if(Math.abs(delta)>3){up=delta<0;lastY=y}
sync();
},{passive:true,signal:this.abort.signal});
window.addEventListener('resize',sync,{passive:true,signal:this.abort.signal});
this.observer=new MutationObserver(sync);
const drawer=document.querySelector('cart-drawer');
if(drawer)this.observer.observe(drawer,{attributes:true,attributeFilter:['class','open']});
sync();
}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
